module.exports = __webpack_public_path__ + "static/TakkScroll4-b8848570ac47aba5bc5ab68d9998c86f.png";